import {useIntl} from 'react-intl'
import 'flatpickr/dist/themes/airbnb.css'
import Flatpickr from 'react-flatpickr'
import {useVIP} from '../../hook'
import moment from 'moment'

export default function useProgramEnums() {
  const intl = useIntl()
  const {program, programSet} = useVIP()

  const handleInputChanges = (e: React.ChangeEvent<HTMLInputElement>) => {
    let {name, value} = e.target
    if (!program) return
    programSet({
      ...program,
      [name]: Number(value),
    })
  }

  const startDate = {
    key: 'startDate',
    title: intl.formatMessage({id: 'VIP.PROGRAM.START.DATE'}),
    subtitle: intl.formatMessage(
      {id: 'VIP.PROGRAM.START.DATE.DESC'},
      {date: moment(program?.startDate).format('MM-DD-YYYY')}
    ),
    description: intl.formatMessage({id: 'VIP.PROGRAM.START.DATE'}),
    footer: intl.formatMessage({id: 'VIP.PROGRAM.START.DATE.SUB'}),
    inputs: [
      {
        label: '',
        value: '',
        description: '',
        render: (disabled: boolean) => {
          return (
            <Flatpickr
              className='form-control'
              disabled={disabled}
              options={{
                enableTime: false,
                dateFormat: 'm-d-Y',
              }}
              placeholder='MM-DD-YYYY'
              value={program?.startDate ? moment(program?.startDate).format('MM-DD-YYYY') : ''}
              name='startDate'
              id='startDate'
              onChange={(date) => {
                if (!program) return
                // const isoStringedDate = moment(date[0]).toISOString()
                // const newDate = isoStringedDate.split('T')[0] + 'T00:00:00.000Z'

                // if (!program) return

                // programSet({
                //   ...program,
                //   startDate: newDate
                // })

                const newDate = moment(date[0]).format('YYYY-MM-DD')

                programSet({
                  ...program,
                  startDate: newDate + 'T00:00:00.000Z',
                })
              }}
            />
          )
        },
      },
    ],
  }

  const status = {
    key: 'status',
    title: intl.formatMessage({id: 'VIP.PROGRAM.STATUS'}),
    subtitle: intl.formatMessage({id: 'VIP.PROGRAM.STATUS.DESC'}),
    description: null,
    footer: null,
    inputs: [
      {
        label: intl.formatMessage({id: 'ACTIVE'}),
        key: 'active',
        value: 1,
        onChange: handleInputChanges,
        isChecked: program?.status === 1,
      },
      {
        label: intl.formatMessage({id: 'DEACTIVE'}),
        key: 'inactive',
        value: 2,
        onChange: handleInputChanges,
        isChecked: program?.status === 2,
      },
    ],
  }

  const entry = {
    key: 'entryMethodType',
    title: intl.formatMessage({id: 'VIP.ENTRY.TITLE'}),
    subtitle: intl.formatMessage(
      {id: 'VIP.ENTRY.DESC'},
      {
        selectedEntry:
          program?.entryMethodType === 1
            ? intl.formatMessage({id: 'VIP.ENTRY.1'})
            : program?.entryMethodType === 2
            ? intl.formatMessage({id: 'VIP.ENTRY.2'})
            : intl.formatMessage({id: 'VIP.ENTRY.3'}),
      }
    ),
    description: null,
    footer: '',
    inputs: [
      {
        label: intl.formatMessage({id: 'VIP.ENTRY.1'}),
        key: 'entry1',
        value: 1,
        onChange: handleInputChanges,
        isChecked: program?.entryMethodType === 1,
      },
      {
        label: intl.formatMessage({id: 'VIP.ENTRY.2'}),
        key: 'entry2',
        value: 2,
        onChange: handleInputChanges,
        isChecked: program?.entryMethodType === 2,
      },
      {
        label: intl.formatMessage({id: 'VIP.ENTRY.3'}),
        key: 'entry3',
        value: 3,
        onChange: handleInputChanges,
        isChecked: program?.entryMethodType === 3,
      },
    ],
  }

  const expiration = {
    key: 'expirationType',
    title: intl.formatMessage({id: 'EXPIRATION'}),
    subtitle: intl.formatMessage(
      {id: 'VIP.EXPIRATION.DESC'},
      {
        selectedExpiration:
          program?.expirationType === 1
            ? intl.formatMessage({id: 'VIP.EXPIRATION.1.LABEL'})
            : intl.formatMessage({id: 'VIP.EXPIRATION.2.LABEL'}),
      }
    ),
    description: null,
    footer: null,
    inputs: [
      {
        label: intl.formatMessage({id: 'VIP.EXPIRATION.1.LABEL'}),
        key: 'expiration1',
        value: 1,
        description: intl.formatMessage({id: 'VIP.EXPIRATION.1.DESC'}),
        onChange: handleInputChanges,
        isChecked: program?.expirationType === 1,
      },
      {
        label: intl.formatMessage({id: 'VIP.EXPIRATION.2.LABEL'}),
        key: 'expiration2',
        value: 2,
        description: intl.formatMessage({id: 'VIP.EXPIRATION.2.DESC'}),
        onChange: handleInputChanges,
        isChecked: program?.expirationType === 2,
      },
    ],
  }

  //status,
  return [entry, startDate, expiration]
}
